/** Decorative "Wanted" placeholder shown after the filled polaroids. */
export const WantedTile = () => (
  <div
    className="flex aspect-[3/4] w-full max-w-[130px] flex-col items-center justify-center rounded-[2px] border-2 border-cream/30 border-dashed px-1.5 py-2 opacity-60 sm:max-w-[180px]"
    style={{ transform: 'rotate(-1deg)' }}
  >
    <div className="font-display font-extrabold text-[9px] text-cream/40 uppercase tracking-[0.18em]">
      Wanted
    </div>
  </div>
);
